// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__hHQl2","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3ymTj","obliqueLine":"membershipbadge_obliqueLine__3r4x4"};